import {
  Input,
  Button,
  Header,
  danger,
  success,
  sendSMS,
  useState,
  useCustomForm,
  SmsBalanceAlert,
} from "@";
import { singleSendSchema, singleSendDefaultValues } from "./utils/validation";

const Single = () => {
  // stats and variables
  const [isSmsBalanceLow, setIsSmsBalanceLow] = useState(true);
  const links = [
    { name: "المراسلات", link: "/messages" },
    { name: "رسالة مخصصة", link: "" },
  ];

  // Use form
  const { reset, register, watch, handleSubmit, errors, isSubmitting } =
    useCustomForm(singleSendDefaultValues, singleSendSchema);

  const getSmsBalance = (value) => setIsSmsBalanceLow(value);

  // send message
  const handleSendMessage = async (data) => {
    try {
      await sendSMS({
        Src: "",
        delayInMin: 0,
        body: data.message,
        RecipientNumbers: [data.phone],
      });
      success("تم الارسال");
      reset();
    } catch (error) {
      danger("حدث خطأ أثناء الإرسال");
    }
  };

  return (
    <>
      <SmsBalanceAlert isShow={getSmsBalance} />
      <Header title="رسالة مخصصة" links={links} />

      <form
        onSubmit={handleSubmit(handleSendMessage)}
        className="relative max-w-2xl"
      >
        <div className="card mb-5 p-4">
          <Input
            style="mb-5"
            label="رقم الجوال"
            error={errors.phone}
            disabled={isSmsBalanceLow}
            input={register("phone")}
          />

          <Input
            style="mb-3"
            type="textarea"
            label="محتوى الرسالة"
            error={errors.message}
            disabled={isSmsBalanceLow}
            input={register("message")}
          />
          <label className="input-label text-gray-400">
            عدد الحروف {watch("message").length}
          </label>
        </div>

        <Button
          type="submit"
          title="إرسال"
          isLoading={isSubmitting}
          disabled={isSmsBalanceLow}
        />
      </form>
    </>
  );
};

export default Single;
